import React from 'react'
import styled, { css } from 'styled-components'
import { ProgressBar as OriginalProgressBar } from 'lib/ProgressBar'
import { Text } from 'lib/Text'

const Container = styled.form`
  display: flex;
  flex: 1 0 100%;
  flex-direction: column;
  flex-wrap: wrap;
`

const ProgressBar = styled(OriginalProgressBar)`
  flex: 1;
  height: 8px;
  transition: background 0.4s;
`

const Row = styled.label<{ $disabled?: boolean }>`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex: 1 0 100%;
  gap: 8px;
  justify-content: space-evenly;
  &:hover ${ProgressBar} {
    background: var(--black-30);
  }

  ${({ $disabled }) =>
    $disabled &&
    css`
      pointer-events: none;
    `}
`

const RadioInput = styled.input`
  display: none;
`

const StarLabel = styled(Text)<{ $disabled: boolean }>`
  display: flex;
  width: 16px;
  justify-content: center;
  align-items: center;
  ${({ $disabled }) =>
    $disabled &&
    css`
      color: var(--black-40);
    `}
`

export interface RatingDistributionProps {
  selectedRating?: number
  ratingDistribution: {
    [key: string]: number
  }[]
  total: number
  onRatingClick?: (mark: number) => void
}

const AVAILABLE_RATINGS = ['5', '4', '3', '2', '1']
const DEFAULT_RATING_ELEMENT = { counter: 0 }

export const RatingDistribution = ({ selectedRating, ratingDistribution, total, onRatingClick }: RatingDistributionProps) => {
  return (
    <Container>
      {AVAILABLE_RATINGS.map((mark, index) => {
        const ratingElement = ratingDistribution.find((element) => Object.keys(element)[0] === mark) || DEFAULT_RATING_ELEMENT
        const value = ratingElement[mark] || 0
        const percent = Math.round((value * 100) / total)

        const disabled = selectedRating ? selectedRating !== +mark : false

        return (
          <Row key={index} $disabled={!onRatingClick || value === 0}>
            <RadioInput type="radio" value={mark} onClick={() => onRatingClick?.(+mark)} />
            <StarLabel weight="semi" size="ps" $disabled={disabled}>
              {mark}
            </StarLabel>
            <ProgressBar percent={value > 0 ? Math.max(percent, 3) : 0} disabled={disabled} />
          </Row>
        )
      })}
    </Container>
  )
}
